import ApiClient from "../ApiClient.ts";

/**
 * Get the central id containing the given coordinates
 * @param {number} wgId the workgroup id
 * @param {number[]} coords the coordinates [lat, lng]
 * @returns {number} the central id
 */
export async function centralContainingCoords(wgId, coords) {
  const response = await ApiClient().get("centrals/locInside", {
    params: {
      wgId,
      loc: JSON.stringify(coords),
    },
  });
  return response.data?.centralId ?? null;
}

/**
 * Get all the centrals for the given workgroup
 * @param {number} wgId the workgroup id
 * @returns {object[]} the centrals
 */
export async function getCentrals(wgId) {
  const response = await ApiClient().get("centrals", {
    params: { wgId },
  });
  return response.data;
}

/**
 * Update the central with the given id
 * @param {number} centralId the central id
 * @param {object} central the central
 */
export async function updateCentral(centralId, central) {
  const response = await ApiClient().patch(`centrals`, central, {
    params: { centralId },
  });
  return response.data;
}
